"use client";!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();
import React from "react"
import dynamic from "next/dynamic"
import SkeletonLoader from "./SkeletonLoader"
import useRedirectToLeaderOnboarding from "../../../hooks/useRedirectToLeaderOnboarding"
/**
 * LazyLoadedSections - A component that handles progressive loading of page sections
 *
 * This component uses Next.js dynamic imports to:
 * 1. Split the page into smaller chunks
 * 2. Load sections progressively as needed
 * 3. Show loading states during section loads
 * 4. Pre-render content on the server for better performance
 */

// Dynamic imports for each section with loading states
// SSR is enabled since content is static, improving initial page load
const FeaturesSection = dynamic(() => import("./FeaturesSection"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

const SuperpowersSection = dynamic(() => import("./SuperpowersSection"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

const ReferralsSection = dynamic(() => import("./ReferralsSection"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

const PricingSection = dynamic(() => import("./PricingSection"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

const AdvertiseSection = dynamic(() => import("./AdvertiseSection"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

const ZestLifeDefinition = dynamic(() => import("./ZestLifeDefinition"), {
  loading: () => <SkeletonLoader />,
  ssr: true,
})

/**
 * Renders all lazy-loaded sections in sequence
 * Each section will:
 * - Be pre-rendered on the server (SSR)
 * - Show a loading state while JavaScript loads
 * - Hydrate on the client when needed
 */
export default function LazyLoadedSections() {
  const [{}, { getRouteForLeaderOnboarding, getMonthlyListingsClickHandler }] =
    useRedirectToLeaderOnboarding()
  return (
    <>
      <ReferralsSection
        getRouteForLeaderOnboarding={getRouteForLeaderOnboarding}
        getMonthlyListingsClickHandler={getMonthlyListingsClickHandler}
      />
      <FeaturesSection getRouteForLeaderOnboarding={getRouteForLeaderOnboarding} />
      <AdvertiseSection getRouteForLeaderOnboarding={getRouteForLeaderOnboarding} />
      {/* <SuperpowersSection /> */}
      <PricingSection />
      <ZestLifeDefinition />
    </>
  )
}
